import { ButtonBase, Stack } from "@mui/material"
import Text from "./Text"
import quizSuccess from "../../../assets/icons/quiz-success.svg"
import quizError from "../../../assets/icons/quiz-error.svg"
import Option from "../../../models/option"
import { colors } from "../../../services/config/colors"
import { useContext } from "react"
import { MainContext } from "../../../controllers/main"

const ToggleButton = ({
  option,
  selected,
  onClick,
  success,
  error,
  disabled,
  withIcons,
}: {
  option: Option
  selected?: boolean
  onClick: (newValue: Option) => void
  success?: boolean
  error?: boolean
  disabled?: boolean
  withIcons?: boolean
}) => {
  const { isMobile } = useContext(MainContext)

  return (
    <ButtonBase
      aria-label={option.label}
      style={{
        width: "100%",
        minHeight: 80,
        backgroundColor: colors.backgroundWhite,
        borderRadius: 24,
        justifyContent: "flex-start",
        padding: 24,
        boxShadow: "0px 0px 24px 0px #93A0A729",
        border: success
          ? `2px solid ${colors.success}`
          : error
          ? `2px solid ${colors.error}`
          : selected
          ? `2px solid ${colors.primary}`
          : `2px solid ${colors.backgroundWhite}`,
        transition: "200ms",
      }}
      onClick={() => {
        onClick(option)
      }}
      disabled={disabled}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        style={{ width: "100%" }}
      >
        <Text
          fontSize={isMobile ? 14 : 20}
          fontWeight={800}
          style={{ flex: 1 }}
          color={success ? colors.success : error ? colors.error : colors.text}
        >
          {option.label}
        </Text>
        {withIcons && (success || error) ? (
          <img
            src={success ? quizSuccess : quizError}
            width={26}
            height={26}
            alt=""
          />
        ) : null}
      </Stack>
    </ButtonBase>
  )
}

export default ToggleButton
